(() => {
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-pm-cart-calendar-trigger]');
    if (!trigger) return;

    document.dispatchEvent(new CustomEvent('pm:delivery-calendar:open', {
      detail: { trigger }
    }));
  });
})();
